const Contact =()=>{
    return (
        <h1 className="text-2xl p-2 m-3">Contact us</h1>
    )
};

export default Contact;